module.exports = __webpack_public_path__ + "static/img/advertisement01.70a9977b.jpg";